<div class="reporting-page">
  <!-- Sidebar with Controls -->
  <aside class="reporting-sidebar">
    <flyfreely-portal-ui-report-side-bar></flyfreely-portal-ui-report-side-bar>
  </aside>

  <!-- Main Content Area with View -->
  <main class="reporting-main">
    <report-view></report-view>
  </main>
</div>
